<template>
    <v-container class="notification" :style="{'max-width': '1300px'}">
      
    <TableCalls :user="user" type="page"/>
    
    </v-container>
</template>

<script>
//import axios from "axios"
import {mapGetters} from 'vuex'
import TableCalls from '@/components/CallCenter/TableCalls.vue'

export default {
    name: 'Calls',
    components:{
      TableCalls
    },

    data: () => ({
      loading: false,
    }),
    mounted(){
      //console.log("mounted page Notification")
    },
    computed: {
      ...mapGetters({
        user: "auth/user",
      }),
    },
    methods:{

    }

}
    

</script>
